// extracted by mini-css-extract-plugin
export default {"tabs-wrapper":"TabbedView_tabs-wrapper__ZHHez","tab-list":"TabbedView_tab-list__dgYPd","tab":"TabbedView_tab__od6Bt","active":"TabbedView_active__HerLw"};